import { createSlice } from '@reduxjs/toolkit';

const customInbound = createSlice({
  name: 'customInbound',
  initialState: {
    customer_name: '',
    amount: 0,
    short_desc: '',
    tnx_date: '',
    product: '',
    quantity: 0,
    payment_type: '',
    confirmCustomInbound: false,
    showProductPopup: false,
    refreshCount: 0,
  },
  reducers: {
    resetCustomInbound: (state) => {
      state.customer_name = '';
      state.amount = '';
      state.short_desc = '';
      state.tnx_date = '';
      state.product = '';
      state.quantity = '';
      state.payment_type = '';
    },
    setConfirmCustomInbound: (state) => {
      state.confirmCustomInbound = true;
    },
    removeConfirmCustomInbound: (state) => {
      state.confirmCustomInbound = false;
    },
    setAllInfo: (state, { payload }) => {
      state.customer_name = payload.originator_account_name;
      state.amount = payload.amount;
      state.short_desc = payload.description;
      state.tnx_date = payload.transaction_date;
      state.product = payload.product_id;
      state.payment_type = payload.payment_type;
      state.quantity = payload.quantity;
    },

    setProductPopup: (state, { payload }) => {
      state.showProductPopup = payload;
    },
    setRefreshCount: (state, { payload }) => {
      state.refreshCount = payload;
    },
  },
});

export const { setConfirmCustomInbound, setAllInfo, resetCustomInbound, removeConfirmCustomInbound, setProductPopup, setRefreshCount } = customInbound.actions;
const customInboundReducer = customInbound.reducer;
export default customInboundReducer;
